import React, { useState } from 'react';
import { Check } from 'lucide-react';
import { motion } from 'framer-motion';
interface ChecklistItem {
  id: string;
  text: string;
}
interface InteractiveChecklistProps {
  title?: string;
  items: ChecklistItem[];
}
export function InteractiveChecklist({
  title,
  items
}: InteractiveChecklistProps) {
  const [checkedItems, setCheckedItems] = useState<Set<string>>(new Set());
  const toggleItem = (id: string) => {
    const newChecked = new Set(checkedItems);
    if (newChecked.has(id)) {
      newChecked.delete(id);
    } else {
      newChecked.add(id);
    }
    setCheckedItems(newChecked);
  };
  return <div className="my-8 rounded-2xl bg-white p-6 md:p-8 shadow-sm border border-sage/20" data-id="element-122">
      {title && <h3 className="font-sans text-xl font-semibold text-forest mb-6 flex items-center gap-2" data-id="element-123">
          <Check className="h-5 w-5 text-sage" data-id="element-124" />
          {title}
        </h3>}
      <div className="space-y-4" data-id="element-125">
        {items.map(item => {
        const isChecked = checkedItems.has(item.id);
        return <button key={item.id} onClick={() => toggleItem(item.id)} className="group flex w-full items-start gap-4 text-left transition-colors" data-id="element-126">
              <div className="relative mt-1 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded border-2 transition-colors duration-200 ease-in-out
                ${isChecked ? 'border-forest bg-forest' : 'border-sage/50 bg-transparent group-hover:border-forest/50'}" style={{
            borderColor: isChecked ? '#2D5016' : '',
            backgroundColor: isChecked ? '#2D5016' : ''
          }} data-id="element-127">
                <div className={`absolute inset-0 rounded border-2 ${isChecked ? 'border-forest bg-forest' : 'border-sage/50 group-hover:border-forest/50'}`} data-id="element-128" />
                <motion.div initial={false} animate={{
              scale: isChecked ? 1 : 0,
              opacity: isChecked ? 1 : 0
            }} transition={{
              type: 'spring',
              stiffness: 300,
              damping: 20
            }} className="absolute z-10 text-white" data-id="element-129">
                  <Check className="h-4 w-4" strokeWidth={3} data-id="element-130" />
                </motion.div>
              </div>
              <span className={`font-serif text-lg transition-colors duration-200 ${isChecked ? 'text-charcoal/50 line-through' : 'text-charcoal'}`} data-id="element-131">
                {item.text}
              </span>
            </button>;
      })}
      </div>
    </div>;
}